<ng-container *transloco="let t">
  <ng-container *ngFor="let input of inputs$ | async">
    <ng-container [ngSwitch]="step.type">
      <!-- string, integer, float -->
      <ng-container *ngSwitchDefault>
        <div>
          <label class="mr-1">{{t('step-common-report.operatorInput')}}:</label><span
            class="font-weight-bold">{{input}}</span>
        </div>
      </ng-container>
      <!-- date -->
      <ng-container *ngSwitchCase="'inputDate'">
        <div>
          <label class="mr-1">{{t('step-common-report.operatorInput')}}:</label><span class="font-weight-bold">
            {{input | date:'dd/MM/yyyy'}}</span>
        </div>
      </ng-container>
      <!-- datetime -->
      <ng-container *ngSwitchCase="'inputDateTime'">
        <div>
          <label class="mr-1">{{t('step-common-report.operatorInput')}}:</label><span class="font-weight-bold">
            {{input | date:'dd/MM/yyyy HH:mm:ss'}}</span>
        </div>
      </ng-container>
      <!-- scanner -->
      <ng-container *ngSwitchCase="'inputScanner'">
        <div>
          <label class="mr-1">{{t('step-common-report.scannerInput')}}:</label><span
            class="font-weight-bold">{{input}}</span>
        </div>
      </ng-container>
      <!-- boolean -->
      <ng-container *ngSwitchCase="'inputTrueFalse'">
        <div>
          <label class="mr-1">{{t('step-common-report.operatorInput')}}:</label><span
            class="text-uppercase font-weight-bold"> {{t('common.' + input)}}</span>
        </div>
      </ng-container>
      <!-- info -->
      <ng-container *ngSwitchCase="'message'">
        <div>
          <label><span class="font-weight-bold">
              {{t('step-common-report.infoViewed')}}
            </span>
          </label>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- innerProcedure -->
  <ng-container *ngIf="step.type === 'innerProcedure'">
    <div>
      <label class="mr-2">{{t('step-common-report.innerProcedureStarted')}}:</label>
      <span class="font-weight-bold">{{innerProcedureId$ | async | procedureName | async}}</span>
    </div>
  </ng-container>
</ng-container>
